export default __webpack_public_path__ + "static/media/icon-facebook.cb241d1c.svg";